import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import {getUserProfileWithDefaults} from 'reducers/user.js';
import UserService from 'services/UserService.js';
import Utils from 'utils/Utils.js';
import DateUtils from 'utils/DateUtils.js';

import {initNavbarState} from 'actions/navbar.js';
import UserEdit from './UserEdit.js';
import ChoosePhotoContainer from './ChoosePhotoContainer.js';



class UserEditContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {validDateText:true,
                      error:null, 
                      busy:false, 
                      complete:false,
                      userProfile:props.userProfile,
                      showChoosePhoto:false,
                      initialMonthYear:(new Date(1980, 0))
                    };
        this.formatDisplay = DateUtils.formatDisplay;
        this.formatServer = DateUtils.formatServer;
        this.onSave = this.onSave.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeBirthDate = this.onChangeBirthDate.bind(this);
        this.onChangeBirthDateText = this.onChangeBirthDateText.bind(this);
        this.onShowChoosePhoto = this.onShowChoosePhoto.bind(this);
        this.onHideChoosePhoto = this.onHideChoosePhoto.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.userProfile.id && Boolean(nextProps.userProfile)) {
            this.setState({userProfile:nextProps.userProfile});
        }
    }
    
    componentWillMount() {
        if(!this.props.noNav) {
            this.props.dispatch(initNavbarState({enable:true, title:this.props.t('Edit Personal Information')}));
        }
    }

    onShowChoosePhoto() {
        this.setState({showChoosePhoto:true});
    }
    onHideChoosePhoto() {
        this.setState({showChoosePhoto:false});
    }

    onSave() {
        this.setState({busy:true});
        UserService.updateProfile({
				userProfile : {
					firstName : this.state.userProfile.firstName,
					lastName  : this.state.userProfile.lastName,
					birthDate : this.state.userProfile.birthDate,
				}
            })
            .then(() => {
                this.setState({complete:true});

                Utils.delay(1000).then(()=>{
                    this.done();
                })

            },function() {
                this.setState({error:this.props.t("Oops! We couldn't save your personal information. Please try again.")});
            }).then(()=>{//always
                this.setState({busy:false});
            })
    }

    done() {
        if(this.props.next) {
            this.props.next(); //hook for use in onboarding
        } else {
            this.props.history.goBack();            
        }
    }

    onChange(event) {
        var {name, value} = event.target;
        this.updateState(name, value);
    }

    onChangeBirthDate(dateLocal) {
        var utc = dateLocal ? moment.utc([dateLocal.year(), dateLocal.month(), dateLocal.date()]) : null;
        var dateStr = (utc&&utc.isValid()) ? utc.format(this.formatServer) : '';
        console.log('birthDateServerStr', dateStr);
        this.setState({validDateText:true});
        this.updateState('userProfile.birthDate', dateStr);
    }
    onChangeBirthDateText(event) {
        var dateText = event.target.value;
        var momentBirthDate = Boolean(dateText) ? moment(dateText, this.formatDisplay, true) : null; 
        console.log('onChangeBirthDateText', dateText, momentBirthDate);
        var validDateText = Boolean(momentBirthDate && momentBirthDate.isValid());
        this.setState({validDateText:validDateText});
    }

    updateState(name, value) {
        this.setState((prevState, props) => (Utils.set({...prevState}, name, value)));
    }

    isValid() {
        return  (this.state.userProfile.firstName &&
                 this.state.userProfile.lastName &&
                 this.state.userProfile.birthDate &&
                 this.state.validDateText);
    }

    render() {
        var momentBirthDate = Boolean(this.state.userProfile.birthDate) ? moment(this.state.userProfile.birthDate, this.formatServer).utc() : null; 
        var birthDateDisplayStr = (momentBirthDate && momentBirthDate.isValid()) ? momentBirthDate.format(this.formatDisplay) : '';
        return (
                <UserEdit {...this.state}
                         latestUserProfile={this.props.userProfile}//If the user profile changes while this form is open (e.g photo updated)
                         onSave={this.onSave}
                         onChange={this.onChange}
                         onChangeBirthDate={this.onChangeBirthDate}
                         onChangeBirthDateText={this.onChangeBirthDateText}
                         format={this.formatDisplay}
                         birthDate={birthDateDisplayStr}
                         initialMonthYear={this.state.initialMonthYear}
                         valid={this.isValid()}
                         onShowChoosePhoto={this.onShowChoosePhoto}>
                    <ChoosePhotoContainer open={this.state.showChoosePhoto} onClose={this.onHideChoosePhoto} />
                </UserEdit>
            );
    }

}



function mapStateToProps(state, ownProps) {
    return { userProfile:getUserProfileWithDefaults(state.user) };
}

export default withRouter(connect(mapStateToProps)(translate('profile')(UserEditContainer)));



// WEBPACK FOOTER //
// ./src/modules/profile/UserEditContainer.js